import { Injectable } from '@angular/core';
import { CampusResource } from '../../models/api/campus-resource.model';

@Injectable({
    providedIn: 'root'
})
export class CampusResourceService {

    constructor() { }

    public findResource(resources: CampusResource[], resourceName: string) {

        var resource = resources.find(r => r.resourceId === resourceName);
        return resource ? resource.value : null;

    }

}
